/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ ago: NonNullable<unknown> }} Connectivity_History_Last_MessageInputs */



/**
* | output |
* | --- |
* | "Last message received {ago}" |
*
* @param {Connectivity_History_Last_MessageInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const connectivity_history_last_message = /** @type {((inputs: Connectivity_History_Last_MessageInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Connectivity_History_Last_MessageInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Last message received ${i?.ago}`)
	return /** @type {LocalizedString} */ (`Dernier message reçu ${i?.ago}`)
});